import messageBus from '../../../common';

/**
 * ContentModifierPlugin
 */
export class ContentModifierPlugin {
    /**
     * @constructor
     *
     * @param componentName
     */
    constructor(componentName) {
        this.componentName = componentName;

        messageBus.subscribe(
            `${componentName}.replaceParams`,
            (eventName, payload) => this.actionReplaceParams(payload)
        );
    }

    /**
     * normaliseSelector
     *
     * @param selector Selector
     *
     * @returns {String} Selector
     */
    normaliseSelector(selector) {
        if (Array.isArray(selector)) {
            return selector.join(', ');
        }

        return selector;
    }

    /**
     * actionReplaceParams
     *
     * @param payload Payload
     */
    actionReplaceParams(payload) {
        const selector = this.normaliseSelector(payload.selector);
        const params = payload.data;

        const elements = document.querySelectorAll(selector);
        Array.prototype.forEach.call(elements, element => {
            Object.keys(params).forEach(key => {
                element.setAttribute(key, params[key]);
            });
        });
    }
}
